import React from "react";

const Legal = () => {
  return (
    <div className="bg-white">
      <section className="relative w-full overflow-hidden">
        <div className="relative w-full h-[300px] md:h-[360px] flex">
          <div
            className="relative z-10 flex items-center text-white"
            style={{
              width: "55%",
              backgroundColor: "#e11d7b",
              clipPath: "polygon(0 0, 100% 0, 92% 35%, 78% 100%, 0 100%)"
            }}
          >
            <div className="max-w-xl pl-8 md:pl-16 pr-10">
              <h1 className="text-4xl md:text-5xl font-extrabold leading-tight">
                Mentions légales
              </h1>
              <p className="mt-4 text-base md:text-lg text-white/90">
                Informations officielles — Maxula S.A.R.L
              </p>
            </div>
          </div>

          <div
            className="absolute right-0 top-0 h-full w-full"
            style={{
              background:
                "linear-gradient(to right, #e11d7b 0%, rgba(225,29,123,0.55) 45%, rgba(225,29,123,0.15) 70%, transparent 100%)"
            }}
          />
        </div>
      </section>

      <section className="py-12">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="bg-white border rounded-2xl p-6 text-gray-700 leading-relaxed">
            <h2 className="text-xl font-bold text-gray-900">Maxula S.A.R.L</h2>
            <p className="mt-2">
              RC : <b>75375</b> — Identifiant fiscal : <b>18766346</b> — Patente : <b>50489114</b> — ICE :{" "}
              <b>001588644000012</b>
            </p>
            <p className="mt-2">
              Siège social : <b>Avenue Beethoven, Résidence Oumnia 1, Bureau 83, Tanger – Maroc</b>
            </p>
            <p className="mt-2">
              Email : <b>contact@maxula.ma</b>
            </p>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Legal;
